
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("lktzL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "RightSidebars", () => $900133482e375240$export$f61c80ac3b95bc7d);
$parcel$export(module.exports, "default", () => $900133482e375240$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cE2Qr = parcelRequire("cE2Qr");

var $1XJ20 = parcelRequire("1XJ20");

var $6jY6G = parcelRequire("6jY6G");

var $4QigF = parcelRequire("4QigF");

var $77Zff = parcelRequire("77Zff");

var $1vv0v = parcelRequire("1vv0v");
const $900133482e375240$export$f61c80ac3b95bc7d = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [allTasksCompleted] = (0, $cE2Qr.useAllTasksCompleted)();
    const previousAllTasksCompleted = (0, $1XJ20.usePreviousWithInitial)(allTasksCompleted);
    if (!(0, $77Zff.shouldRouteShowQuickstartOnboarding)(route.name)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, allTasksCompleted === true && previousAllTasksCompleted === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vv0v.OnboardingConfettiAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.JswOnboardingChecklist), null));
};
var $900133482e375240$export$2e2bcd8739ae039 = $900133482e375240$export$f61c80ac3b95bc7d;

});
parcelRegister("77Zff", function(module, exports) {

$parcel$export(module.exports, "shouldRouteShowQuickstartOnboarding", () => $0ba707d97438beee$export$25ddf6cfdf6af9c5);

var $c0dQj = parcelRequire("c0dQj");
const $0ba707d97438beee$var$allowedRoutes = new Set([
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-approvals',
    'classic-business-list',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-form',
    'classic-business-form-builder',
    'project-pages'
]);
const $0ba707d97438beee$export$25ddf6cfdf6af9c5 = (routeName)=>{
    if ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)()) return false;
    return $0ba707d97438beee$var$allowedRoutes.has(routeName);
};

});

parcelRegister("1vv0v", function(module, exports) {

$parcel$export(module.exports, "OnboardingConfettiAsync", () => $a3748185be00dcfb$export$aa3f6e97ec5efe9d);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kVzzn = parcelRequire("kVzzn");
const $a3748185be00dcfb$var$runtimeProps = {};
const $a3748185be00dcfb$var$entryPointParams = {};
const $a3748185be00dcfb$export$aa3f6e97ec5efe9d = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kVzzn.onboardingConfettiEntrypoint), $a3748185be00dcfb$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jwm-onboarding-confetti",
        packageName: "businessProjectLayout",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $a3748185be00dcfb$var$runtimeProps
    });
};

});
parcelRegister("kVzzn", function(module, exports) {

$parcel$export(module.exports, "onboardingConfettiEntrypoint", () => $10d623a8e6846f1c$export$cad907bd07dbd647);

var $auHvw = parcelRequire("auHvw");

var $9zf4T = parcelRequire("9zf4T");

const $10d623a8e6846f1c$export$cad907bd07dbd647 = (0, $9zf4T.createEntryPoint)({
    root: (0, $auHvw.JSResourceForInteraction)(()=>(parcelRequire("a5mVt")), {
        moduleId: "f0d91b27"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("a5mVt", function(module, exports) {

let $757c27a2fc0b7136$var$load = (parcelRequire("28QjX"))(4);
module.exports = $757c27a2fc0b7136$var$load("lqIfG").then(()=>parcelRequire('jCz4V'));

});





//# sourceMappingURL=async-business-project-right-sidebars.93bee7a0.js.map
